//#region src/core/composition/define-behavior.ts
function defineBehavior(behavior) {
	return behavior;
}
//#endregion
export { defineBehavior };
